/**
 * Vantage Core API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

export interface PaymentSummaryViewModel {
  procedureTransactionId?: string;
  statusAccepted?: string | null;
  postedDate?: string | null;
  insurance?: string | null;
  paymentType?: string | null;
  checkNumber?: string | null;
  paymentCode?: string | null;
  paymentCodeName?: string | null;
  batchNumber?: number;
  batchType?: string | null;
  batchId?: string | null;
  adjustmentCode?: string | null;
  adjustmentCodeName?: string | null;
  icn?: string | null;
  eobCodes?: string | null;
  eobDescriptions?: string | null;
  remarkCodes?: string | null;
  remarkDescriptions?: string | null;
  allowedAmount?: number;
  paymentAmount?: number;
  adjustmentAmount?: number;
  deductibleAmount?: number;
  copayAmount?: number;
  coinsuranceAmount?: number;
}
